
import { useState } from 'react';

import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import Button from 'src/onboarding/components/ui/button/Button';

import { Title } from 'src/onboarding/components/typography/Title/Title';
import { MultiCheck } from 'src/onboarding/components/ui/multi-check/MultiCheck';
import { MultiOption } from 'src/onboarding/components/ui/multi-check/Option';

import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const progressTracking = useStore((state) => state.progressTracking);
  const setProgressTracking = useStore((state) => state.setProgressTracking);
  const [next, setNext] = useState(progressTracking.length > 0);
  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setProgressTracking(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.progressTracking.title')}</Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={progressTracking} onChange={handleChange}>
          <MultiOption value={'Check my weight regularly'}>
            <span>⚖️</span> {t('onboarding.progressTracking.options.check')}
          </MultiOption>
          <MultiOption value={'Track body measurements'}>
            <span>📏</span> {t('onboarding.progressTracking.options.track')}
          </MultiOption>
          <MultiOption value={'Monitor health stats with a fitness app'}>
            <span>📱</span> {t('onboarding.progressTracking.options.monitor')}
          </MultiOption>
          <MultiOption value={'Watch changes in energy levels'}>
            <span>🔋</span> {t('onboarding.progressTracking.options.watch')}
          </MultiOption>
          <MultiOption value={'Compare how my clothes fit now vs before'}>
            <span>👗</span> {t('onboarding.progressTracking.options.compare')}
          </MultiOption>
          <MultiOption value={'Other'}>
            <span>✨</span> {t('onboarding.progressTracking.options.other')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.progressTracking.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'progress-tracking',
              answer: progressTracking.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}

export default Page;
